var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.875C8.875 8.57663 8.99353 8.29048 9.20451 8.07951C9.41548 7.86853 9.70163 7.75 10 7.75C10.2984 7.75 10.5845 7.86853 10.7955 8.07951C11.0065 8.29048 11.125 8.57663 11.125 8.875V10H8.875V8.875Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4546 1H5.5C4.90326 1 4.33097 1.23705 3.90901 1.65901C3.48705 2.08097 3.25 2.65326 3.25 3.25V16.75C3.25 17.3467 3.48705 17.919 3.90901 18.341C4.33097 18.7629 4.90326 19 5.5 19H14.5C15.0967 19 15.669 18.7629 16.091 18.341C16.5129 17.919 16.75 17.3467 16.75 16.75V6.29537C16.7499 5.99703 16.6314 5.71093 16.4204 5.5L12.25 1.32963C12.0391 1.11863 11.753 1.00006 11.4546 1ZM11.6875 4.9375V2.6875L15.0625 6.0625H12.8125C12.5141 6.0625 12.228 5.94397 12.017 5.733C11.806 5.52202 11.6875 5.23587 11.6875 4.9375ZM12.25 8.875V10.0855C12.8575 10.2723 13.375 10.7571 13.375 11.4625V14.1625C13.375 15.0805 12.4964 15.625 11.6875 15.625H8.3125C7.50362 15.625 6.625 15.0805 6.625 14.1625V11.4625C6.625 10.7571 7.1425 10.2723 7.75 10.0855V8.875C7.75 8.27826 7.98705 7.70597 8.40901 7.28401C8.83097 6.86205 9.40326 6.625 10 6.625C10.5967 6.625 11.169 6.86205 11.591 7.28401C12.0129 7.70597 12.25 8.27826 12.25 8.875Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseIcon);
export default __webpack_public_path__ + "static/media/warehouseIcon.732b03ae23a39f611f143fb41c628d2a.svg";
export { ForwardRef as ReactComponent };